import { z } from 'zod';

export enum IntegrationType {
  SIMPHONY = 'integrations:simphony',
  OPERA = 'integrations:opera',
  STAY_N_TOUCH = 'integrations:stayntouch',
  KICC = 'integrations:kicc',
  REVINATE = 'integrations:revinate',
  ALICE = 'integrations:alice',
  INFOR = 'integrations:infor',
  ADOBE_ANALYTICS = 'integrations:adobeAnalytics',
  GA4_ANALYTICS = 'integrations:ga4Analytics',
  GTM_ANALYTICS = 'integrations:gtmAnalytics',
  TEALIUM_ANALYTICS = 'integrations:tealiumAnalytics',
  MEWS = 'integrations:mews',
}

export enum IntegrationName {
  ADOBE_ANALYTICS = 'adobeAnalytics',
  ALICE = 'alice',
  GTM_ANALYTICS = 'gtmAnalytics',
  GA4_ANALYTICS = 'ga4Analytics',
  INFOR = 'infor',
  KICC = 'kicc',
  MEWS = 'mews',
  OPERA = 'opera',
  REVINATE = 'revinate',
  SIMPHONY = 'simphony',
  STAYNTOUCH = 'stayntouch',
  TEALIUM_ANALYTICS = 'tealiumAnalytics',
}

export enum IntegrationKeys {
  TransactionCode = 'transactionCode',
  IntegrationAddOn = 'integrationAddOn',
  TenderId = 'tenderId',
  LocRef = 'locRef',
  RvcRef = 'rvcRef',
  MenuId = 'menuId',
  MenuItemId = 'menuItemId',
  MewsTaxCodes = 'mewsTaxCodes',
}

const stripIntegrationPrefix = (str: string) => (str || '').replace('integrations:', '');

export const integrationUrl = ({ brandId, integrationType }: { brandId: string; integrationType: IntegrationType }) =>
  `v1/brands/${brandId}/integrations/${stripIntegrationPrefix(integrationType)}`;

export const IntegrationConfigResponseSchema = z.record(z.unknown());

export enum IntegrationGroup {
  PMS = 'pms',
  CRM = 'crm',
  ANALYTICS = 'analytics',
}

export const Integrations = {
  [IntegrationGroup.CRM]: [IntegrationName.ALICE, IntegrationName.REVINATE],
  [IntegrationGroup.PMS]: [IntegrationName.INFOR, IntegrationName.OPERA, IntegrationName.STAYNTOUCH, IntegrationName.MEWS],
  [IntegrationGroup.ANALYTICS]: [
    IntegrationName.ADOBE_ANALYTICS,
    IntegrationName.GA4_ANALYTICS,
    IntegrationName.GTM_ANALYTICS,
    IntegrationName.TEALIUM_ANALYTICS,
  ],
} as const;
